export const APP_TITLE = "Programmer's Diary";
export const COPYRIGHT_YEARS = '2025-2026';
export const AUTHOR_NAME = 'Alexander Savinykh';
